import Chooseprepayment from '../Chooseprepayment';
import ChooseAcution from '../chooseAcution';

interface SuggestionListProps {
  postType: string;
  is_saled: boolean;

  chosedSugestionUser: IChosedSugestionUser;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}

export const convertorSuggestionList: Record<
  string,
  (data: SuggestionListProps) => JSX.Element
> = {
  auction: data => (
    <ChooseAcution
      is_saled={data.is_saled}
      postTypes={data.postType}
      chosedSugestionUser={data.chosedSugestionUser}
      setChosedSugestionUser={data.setChosedSugestionUser}
    />
  ),
  sale: () => <></>,
  prepayment: data => (
    <Chooseprepayment
      postTypes={data.postType}
      chosedSugestionUser={data.chosedSugestionUser}
      setChosedSugestionUser={data.setChosedSugestionUser}
    />
  ),
};
